/* RESPONSIBLE TEAM: team-standalone */

import Controller from '@ember/controller';
import { action } from '@ember/object';

export default class AppStandaloneDeployFreshdeskTicketsWorkflowController extends Controller {
  // Using queryParams is the recommended usage for controllers in this codebase
  queryParams = ['openSection'];

  // Default value for query param
  openSection = null;

  @action
  setSection(sectionId) {
    this.openSection = sectionId;
  }
}
